import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
 import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCarouselModule } from 'ngx-carousel';
import { ArchwizardModule } from 'angular-archwizard';
import { ImageCropperModule } from 'ng2-img-cropper';
import { cardPortletRefresh, cardPortletDelete } from './directives/cards.directive';
import { FieldErrorDisplayComponent } from './components/field-error-display/field-error-display.component';
import { ValidatorCustomService } from '../services/validator-custom.service';
import { AuthInterceptorService } from '../services/auth-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatPaginatorModule } from '@angular/material';
import { GetUnixService } from '../services/get-unix.service';
import { RealTimePipe } from './pipes/real-time.pipe';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { FileUploadService } from '../services/upload.service';
import { ImageNamePipe } from './pipes/image-name.pipe';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import {MatTabsModule} from '@angular/material/tabs';

import { LoadingModule } from 'ngx-loading';
import { FlexLayoutModule } from "@angular/flex-layout";
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { DndModule } from 'ngx-drag-drop';
import {MatListModule} from '@angular/material/list';


@NgModule({
    declarations: [
        cardPortletRefresh,
        cardPortletDelete,
        FieldErrorDisplayComponent,
        RealTimePipe,
        ImageNamePipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatTabsModule,
        ReactiveFormsModule,
        NgxCarouselModule,
        ArchwizardModule,
        ModalModule.forRoot(),
        BsDatepickerModule.forRoot(),
        ScrollToModule.forRoot(),
        ImageCropperModule,
        MatPaginatorModule,
        MatCheckboxModule,
        InfiniteScrollModule,
        LoadingModule,
        PerfectScrollbarModule,
        FlexLayoutModule,
        DndModule  ,
        MatListModule
    ],
    exports: [
        cardPortletRefresh,
        NgxCarouselModule,
        cardPortletDelete,
        ModalModule,
        RealTimePipe,
        BsDatepickerModule,
        FormsModule,
        ReactiveFormsModule,
        ArchwizardModule,
        ImageCropperModule,
        FieldErrorDisplayComponent,
        ScrollToModule,
        MatPaginatorModule,
        InfiniteScrollModule,
        MatCheckboxModule,
        ImageNamePipe,
        LoadingModule,
        PerfectScrollbarModule,
        FlexLayoutModule,
        DndModule,
        MatListModule,
      
    ],
    providers: [
        ValidatorCustomService,
        GetUnixService,
        FileUploadService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptorService,
          multi: true
        }
    ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/shared/shared.module.ts